export const HEADER_HEIGHT = { PC: 65, SP: 57 }
export const OFFSET_TOP = { PC: -(95 + HEADER_HEIGHT.PC), SP: -(82 + HEADER_HEIGHT.SP) }
